import React, { Fragment, Component, h} from "preact";
import Modal from "../../_common/components/Modal/index";
import {FR} from "../../_common/layout";
import {t} from "../../_i18n";
import { ButtonLink } from '../../_common/components/buttons/buttons';
import { useState } from 'preact/hooks';
import { Checkbox } from "../../_common/forms/components/Checkbox/Checkbox";
import ButtonSpinner from "../../_common/components/buttons/buttonSpinner/buttonSpinner";
import "./modal-postponement-styles.scss"
import AlertBox from "../../_common/components/AlertBox/AlertBox";
import { formatDateLong, handleSafeClick } from "../../utils";

export default function PostponementModal({ visible, studentId, enroll, action, period,onAction, onClose}){
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);
    const isDisabled = !checked || loading;

    const handleAction = async () => {
        setLoading(true)
        await onAction(studentId, enroll.last_enroll_id)
        setChecked(false)
        setLoading(false)
    }

    const handleChecked = (checkVal) => {
        setChecked(checkVal)
    }

    const getBodyText = () => {
        const text = t(`modal_${action}_enroll_body`)

        if (action === 'postpone' && enroll.resume_enroll_date) {
            const dateDetails = formatDateLong(enroll.resume_enroll_date)
            const dateString = `${dateDetails[1]} de ${dateDetails[2]}`
            return text.replace('{resume_date}', dateString)
        }

        if (action === 'resume') {
            const periodString = period === 'current' ? t('Semestre actual') : t('Próximo semestre')
            return text.replace('{semester}', periodString.toLowerCase())
        }

        return text
    }

    const getCheckboxText = () => {
        const text = t(`accept_${action}_enroll_check`)

        if (action === 'resume') {
            const periodString = period === 'current' ? t('Semestre actual') : t('Próximo semestre')
            return text.replace('{semester}', periodString.toLowerCase())
        }

        return text
    }

    return (
        <Modal visible={visible} closeModal={onClose} bodyClass='sm-m-top modal-postponement'>
            <FR className={'modal-title-padding row-2-el p-all p-x2-left p-x2-right'}>
                <div className='col-80'>
                    <p className="t-left font-24 font-bold no-margin">{t(`modal_${action}_enroll_title`)}</p>
                </div>
                <div className={'t-right col-20'}>
                    <a onClick={onClose} className="modal-close-jobs modal-link">
                        <i className="fal fa-times font-20"/>
                    </a>
                </div>
            </FR>
            <hr className="separator-xxs no-margin-top"/>
            <div className='modal-postponement__body'>
                <p className={'font-bold'}>{`${enroll?.formative_action_code}: ${enroll?.formative_action_title}`}</p>
                {(enroll?.is_project || enroll?.is_catalan) &&
                    <AlertBox type={'warning'} className={'m-top m-bottom'}>
                        <span dangerouslySetInnerHTML={{__html:t('modal-postpone-combined')}} />
                    </AlertBox>
                }
                <AlertBox type={'info'} className={'m-top m-bottom'}>
                    <span dangerouslySetInnerHTML={{__html:getBodyText()}} />
                </AlertBox>
                {action === 'postpone' &&
                    <span dangerouslySetInnerHTML={{__html: t('modal-postpone-reminder')}}/>
                }
                <Checkbox
                    className="modal-postponement__accept"
                    labelIsClicked={true}
                    value={checked}
                    onChange={value => handleChecked(value)}
                    label={getCheckboxText()}
                />
            </div>
            <hr className="separator-xxs no-margin"/>
            <div className='modal-postponement__footer'>
                <ButtonSpinner classNameContainer={'full-width sm-no-full-width'}
                    showSpinner={loading} disabled={!checked} onClick={handleSafeClick(handleAction, isDisabled)}>
                    {action === 'postpone' ? t('postpone_enroll') : t('activate_enroll')}
                </ButtonSpinner>
                <ButtonLink className="full-width sm-no-full-width sm-d-block d-none" onClick={onClose}>{t('Cancelar')}</ButtonLink>
            </div>

        </Modal>
    )
}
